export default __webpack_public_path__ + "static/media/Comp 2_00009.5e41f367.png";